import type { FareAttribute } from '../../schema/row-types.ts';
import type {
  RowOrderBy,
  RowQuery,
  SqliteQueryOptions,
} from '../../types/query.ts';
import { fareAttributes } from '../../schema/tables/gtfs-schedule/fare-attributes.ts';
import { findRows } from '../sqlite-query.ts';

/**
 * Returns an array of all fare attributes that match the query parameters.
 * @param query Column values to match, as single values or arrays
 * @param fields Columns to select, or every column when empty
 * @param orderBy Column and direction pairs to sort by
 * @param options Query options, including the database to read from
 * @returns Matching rows, containing only `fields` when it is not empty
 */
export function getFareAttributes<Fields extends keyof FareAttribute>(
  query: RowQuery<FareAttribute> = {},
  fields: readonly Fields[] = [],
  orderBy: RowOrderBy<FareAttribute> = [],
  options: SqliteQueryOptions = {},
) {
  return findRows<FareAttribute, Fields>(
    fareAttributes,
    query,
    fields,
    orderBy,
    options,
  );
}
